import { Coffee } from "lucide-react";

const PAYPAL_EMAIL = "campanaf89@gmail.com";

const buildUrl = () => {
  const ret = `${window.location.origin}/grazie`;
  return (
    `https://www.paypal.com/cgi-bin/webscr?cmd=_xclick` +
    `&business=${encodeURIComponent(PAYPAL_EMAIL)}` +
    `&currency_code=EUR&amount=1.50` +
    `&item_name=${encodeURIComponent("Offrimi un caffè — Il Cassetto delle Giraffe")}` +
    `&return=${encodeURIComponent(ret)}&rm=1`
  );
};

export const CoffeeSupport = () => (
  <div
    data-testid="coffee-support"
    className="my-14 rounded-2xl border border-[#E7D6B8] p-8 md:p-10 text-center"
    style={{ background: "linear-gradient(135deg,#FBF2DE 0%,#F6E3C0 100%)" }}
  >
    <div className="flex justify-center mb-4">
      <span className="flex items-center justify-center w-14 h-14 rounded-full bg-[#9F583F]/12 text-[#9F583F]">
        <Coffee size={28} strokeWidth={1.6} />
      </span>
    </div>
    <h3 className="font-display text-2xl md:text-3xl tracking-tight text-[#1C1917]">
      Ti è piaciuto questo articolo?
    </h3>
    <p className="font-body text-[#57534E] mt-3 max-w-md mx-auto leading-relaxed">
      Se ti ha fatto compagnia o incuriosito, offrimi un caffè: un piccolo gesto
      che aiuta il Cassetto delle Giraffe a restare vivo.
    </p>
    <a
      href={buildUrl()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="coffee-donate-button"
      className="mt-6 inline-flex items-center justify-center gap-2 bg-[#9F583F] hover:bg-[#1C1917] text-white label-ui px-7 py-4 transition-colors"
    >
      <Coffee size={16} strokeWidth={1.8} /> Offrimi un caffè (1,50 €)
    </a>
  </div>
);
